import { useEffect } from 'react';
import { useSocieta } from '../context/SocietaContext';

interface Args {
  /**
   * societaId del record. Finché è undefined/null, l'hook NON registra alcun blocco
   * (attesa della fetch iniziale).
   */
  recordSocietaId?: number | null;
  /**
   * Etichetta human-readable mostrata nella modale di blocco.
   * Es: "Offerta Capitolato OFC-2024-001", "Commessa C-101", "Finanziamento #42".
   */
  label: string;
}

/**
 * Blocca il cambio di società mentre l'utente è in una scheda di dettaglio.
 * Da chiamare SUBITO nelle pagine /:id, dopo aver ricevuto la prima risposta
 * dalla fetch del record (cioè quando si conosce `recordSocietaId`).
 *
 * - Finché `recordSocietaId` è null/undefined, l'hook non fa nulla (attesa fetch)
 * - Al primo valore valido, registra un blocco nel SocietaContext
 * - Al unmount del componente (o quando `recordSocietaId` torna nullish),
 *   rimuove il blocco
 */
export function useBloccoRecordContesto({ recordSocietaId, label }: Args) {
  const { registraBloccoContesto, rimuoviBloccoContesto } = useSocieta();

  useEffect(() => {
    if (!recordSocietaId) return;
    registraBloccoContesto({ label, recordSocietaId });
    return () => {
      rimuoviBloccoContesto();
    };
  }, [recordSocietaId, label, registraBloccoContesto, rimuoviBloccoContesto]);
}
